import { useSubscriptionStore } from '@/stores/subscriptionStore'
import { useBrandStore } from '@/stores/brandStore'
import { isMsisdnValid, formatMsisdn } from '@/functions/isMsisdnValid'
import getCampaignParametersFromUrl from '@/functions/getCampaignParametersFromUrl'
import router from '@/router'

export const MSISDN_PARAMS = ['msisdn', 'tn', 'mobileNumber']
const MSISDN_STORAGE_KEY = 'wr-lp-msisdn'

// Bootstraps the visitor: attribution first (independent of the msisdn resolution below), then the
// msisdn from the nginx HE bootstrap, the URL, or storage. Only the server bootstrap counts as HE.
export default async function userAuthenticate() {
  const subscriptionStore = useSubscriptionStore()
  const { brandConfig } = useBrandStore()
  const rules = brandConfig.msisdn

  // The URL rewrite below must resolve against the landed route, not the router's start location.
  await router.isReady()
  subscriptionStore.setCampaignParameters(getCampaignParametersFromUrl())

  const enriched = resolveHeaderEnrichment()
  if (enriched && isMsisdnValid(enriched, rules)) {
    applyMsisdn(subscriptionStore, formatMsisdn(enriched, rules), true)
    return
  }

  const msisdn = resolveMsisdn(rules)
  if (msisdn) applyMsisdn(subscriptionStore, msisdn, false)
}

// window.__WR_HE__ is injected by nginx/nginx.conf from any request header whose name contains "msisdn".
// The value is used as-is; a market whose header is encrypted decodes it via its integration service.
function resolveHeaderEnrichment() {
  const bootstrap = window.__WR_HE__
  delete window.__WR_HE__
  return bootstrap?.headerEnriched && bootstrap.value ? bootstrap.value : null
}

function resolveMsisdn(rules) {
  const params = new URLSearchParams(window.location.search)
  for (const key of MSISDN_PARAMS) {
    const value = params.get(key)
    if (isMsisdnValid(value, rules)) return formatMsisdn(value, rules)
  }
  const stored = localStorage.getItem(MSISDN_STORAGE_KEY)
  return isMsisdnValid(stored, rules) ? formatMsisdn(stored, rules) : null
}

// Persists the msisdn and strips it from the URL so the number never lingers in the address bar.
function applyMsisdn(subscriptionStore, msisdn, headerEnriched) {
  subscriptionStore.msisdn = msisdn
  subscriptionStore.headerEnriched = headerEnriched
  localStorage.setItem(MSISDN_STORAGE_KEY, msisdn)

  const params = new URLSearchParams(window.location.search)
  MSISDN_PARAMS.forEach((key) => params.delete(key))
  router.replace({ path: router.currentRoute.value.path, query: Object.fromEntries(params.entries()) })
}
